import React from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { PropTypes } from 'prop-types';

const MultiSelectPM = ({ itemKey = '', value = '', display = '', options = '', optionLabel = '', onChange = '', inlineStyle = '' }) => {
  MultiSelectPM.propTypes = {
    itemKey: PropTypes.string,
    value: PropTypes.array,
    display: PropTypes.string,
    options: PropTypes.array,
    optionLabel: PropTypes.string,
    onChange: PropTypes.func,
    inlineStyle: PropTypes.any,
  };

  return (
    <MultiSelect
      id="multiselectPM"
      display={display}
      key={itemKey}
      value={value}
      options={options}
      optionLabel={optionLabel && optionLabel.length ? optionLabel : 'header'}
      onChange={onChange}
      style={inlineStyle}
    />
  );
};

export default MultiSelectPM;